import React, {useState, useEffect} from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom"; 
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Batteries from "./pages/Batteries";
import Battery from './pages/Battery';
import Contact from './pages/Contact';
import Map from './pages/Maps';
import NoPage from "./pages/NoPage";


//backup data 
import db from './db.json';
import './App.css';

function App() {
  
  //store data temporarily 
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const markers = data && data.map(da => da.location === 'STREET' ? {...da.locate} : {})
  console.log(markers, 'markers array')
  
  //individual battery  
  //feth data once per page load
  useEffect(() => {
    //the original fake data api is not working  that is why
    // json server is used
    //fetch('https://f2byongc84.execute-api.eu-central-1.amazonaws.com/webdev_test_fetch_batteries')
    
    fetch('http://localhost:3003/batteries')
     .then(response => response.json())
     .then(data => 
      setData(data),
      setError('')
    )
    .catch(err => 
      setError('Loading data from server is not successful,  fething data is pulled from db.json backup'),
      setTimeout(() => {
        setError('')
      }, 2000),
      setData(db.batteries),
      setError('')
    )
    
     }, 
  [])
  
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="batteries" element={<Batteries data={data}  error={error} />} />
          <Route path="batteries/:id" element={<Battery  />} />
          <Route path="contact" element={<Contact  />} />
          <Route path="maps" element={<Map markers={markers} />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
